module.exports = __webpack_public_path__ + "img/bolivia.9b648731.png";